var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRmLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m118,36c0,8.96-6.07,17.42-16.6,23.74-10.5,6.3-25.13,10.26-41.4,10.26s-30.9-3.96-41.4-10.26c-10.54-6.32-16.6-14.78-16.6-23.74s6.07-17.42,16.6-23.74C29.1,5.96,43.73,2,60,2s30.9,3.96,41.4,10.26c10.54,6.32,16.6,14.78,16.6,23.74Z",
    stroke: "currentColor",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m46.37,43.1l8.34,5.32h0l-2.24,3.52-19.29-12.3v12.36h-4.17v-31.31h4.17v4.42c2.13-3.08,5.69-5.11,9.72-5.11,6.52,0,11.81,5.29,11.81,11.81,0,5.31-3.51,9.8-8.33,11.29Zm4.16-11.29c0-4.21-3.42-7.64-7.63-7.64s-7.63,3.43-7.63,7.64,3.42,7.64,7.63,7.64,7.63-3.43,7.63-7.64Zm35.52,10.55v-21.68h4.17v31.31h-4.17l-9.39-21.68v21.68h-4.17l-9.39-21.68v21.68h-4.17v-31.31h4.17l9.39,21.68v-21.68h4.17l9.39,21.68Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmLogo2);
export default __webpack_public_path__ + "static/media/rm-logo-2.9895cb4743039bdf4b885a64eec35913.svg";
export { ForwardRef as ReactComponent };